"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommonBankAccountValidator = /** @class */ (function () {
    function CommonBankAccountValidator() {
    }
    CommonBankAccountValidator.prototype.normalize = function (bankAccount) {
        if (!bankAccount.bankNumber)
            bankAccount.bankNumber = "";
        if (!bankAccount.agencyNumber)
            bankAccount.agencyNumber = "";
        if (!bankAccount.agencyCheckNumber)
            bankAccount.agencyCheckNumber = "";
        if (!bankAccount.accountNumber)
            bankAccount.accountNumber = "";
        if (!bankAccount.accountCheckNumber)
            bankAccount.accountCheckNumber = "";
        if (bankAccount.bankNumber)
            bankAccount.bankNumber = parseInt(bankAccount.bankNumber).toString();
        if (bankAccount.agencyNumber)
            bankAccount.agencyNumber = parseInt(bankAccount.agencyNumber).toString();
        if (bankAccount.accountNumber)
            bankAccount.accountNumber = parseInt(bankAccount.accountNumber).toString();
        if (bankAccount.accountCheckNumber)
            bankAccount.accountCheckNumber = parseInt(bankAccount.accountCheckNumber).toString();
        while (bankAccount.bankNumber.length < 3)
            bankAccount.bankNumber = "0" + bankAccount.bankNumber;
        while (bankAccount.agencyNumber.length < this.agencyNumberLength())
            bankAccount.agencyNumber = "0" + bankAccount.agencyNumber;
        while (bankAccount.accountNumber.length < this.accountNumberLength())
            bankAccount.accountNumber = "0" + bankAccount.accountNumber;
        while (bankAccount.accountCheckNumber.length < 1)
            bankAccount.accountCheckNumber = "0" + bankAccount.accountCheckNumber;
    };
    CommonBankAccountValidator.prototype.accountCheckNumberMatch = function (bankAccount) {
        return true;
    };
    CommonBankAccountValidator.prototype.agencyCheckNumberMatch = function (bankAccount) {
        return true;
    };
    CommonBankAccountValidator.prototype.agencyNumberIsValid = function (agencyNumber) {
        return /^(?!0000)([0-9]{4})$/.test(agencyNumber);
    };
    CommonBankAccountValidator.prototype.agencyCheckNumberIsValid = function (agencyCheckNumber) {
        if (!agencyCheckNumber)
            agencyCheckNumber = "";
        return /^[a-zA-Z0-9]{0,1}$/.test(agencyCheckNumber);
    };
    CommonBankAccountValidator.prototype.accountNumberIsValid = function (accountNumber) {
        return /^[0-9]{1,12}$/.test(accountNumber) && parseInt(accountNumber) > 0;
    };
    CommonBankAccountValidator.prototype.accountCheckNumberIsValid = function (accountCheckNumber) {
        if (!accountCheckNumber)
            accountCheckNumber = "";
        return /^[a-zA-Z0-9]{1}$/.test(accountCheckNumber);
    };
    CommonBankAccountValidator.prototype.agencyNumberMsgError = function () {
        return "A agência deve conter " + this.agencyNumberLength() + " números. Complete com zeros a esquerda se necessário.";
    };
    CommonBankAccountValidator.prototype.agencyCheckNumberMsgError = function () {
        var length = this.agencyCheckNumberLength();
        if (!length) {
            return "Não insira dígito da agência";
        }
        else if (length === 1) {
            return "O dígito da agência deve conter 1 dígito";
        }
        else {
            return "O dígito da agência deve conter " + length + " números. Complete com zeros a esquerda se necessário.";
        }
    };
    CommonBankAccountValidator.prototype.accountNumberMsgError = function () {
        return "A conta corrente deve conter " + this.accountNumberLength() + " números. Complete com zeros a esquerda se necessário.";
    };
    CommonBankAccountValidator.prototype.agencyNumberLength = function () {
        return 4;
    };
    CommonBankAccountValidator.prototype.agencyCheckNumberLength = function () {
        return 0;
    };
    CommonBankAccountValidator.prototype.accountNumberLength = function () {
        return 0;
    };
    return CommonBankAccountValidator;
}());
exports.default = CommonBankAccountValidator;
//# sourceMappingURL=CommonBankAccountValidator.js.map